<template>
  <Adminlte>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="box box-primary center-block">
          <div class="box-header with-border">
            <h3 class="box-title">Editar Parceiro</h3>
          </div>
          <PartnerForm :partner="partner" :errors="errors" :onSubmit="onSubmit"></PartnerForm>
        </div>
      </div>
    </div>
    <notifier ref="notifier"></notifier>
  </Adminlte>
</template>
<script>
  import Adminlte from '@/components/template/Adminlte'
  import PartnerClient from '@/services/resource_client/partner'
  import PartnerForm from '@/pages/partners/PartnerForm'
  import Notifier from '@/components/elements/Notifier'

  export default {
    name: 'EditPartner',
    components: { Adminlte, PartnerForm, Notifier },
    data: function () {
      return {
        partner: {},
        errors: {}
      }
    },
    props: ['id'],
    methods: {
      onSubmit () {
        PartnerClient.put(this.partner)
          .then(r => {
            this.$refs.notifier.showSavedFormNotification()
            this.errors = {}
            this.$router.push({ name: 'Partners' })
          })
          .catch(e => {
            this.errors = e.response.data.errors
            this.$refs.notifier.showErrorNotification()
          })
      }
    },
    created () {
      PartnerClient.get(this.id)
        .then(r => {
          this.partner = r.data
        })
    }
  }
</script>



// WEBPACK FOOTER //
// EditPartner.vue?776c5626